import React from 'react';
import { useTranslation } from 'react-i18next';
import { Features } from './Features';
import { Licences } from './Licenses';
import DocTemplate from '../DocTemplate';
import { Theme, useMediaQuery } from '@material-ui/core';
import DownloadTemplate from '../DownloadTemplate';

const General = () => {
  const { t } = useTranslation('documentation');
  const matchDownSm = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <DownloadTemplate
      imageSrc={'/images/views/pricing/header.svg'}
      title={''}
      to={'/pricing'}
      cta={t('general.headers.button')}
      bottomRightImage={{
        src: '/images/views/documentation/general/loupe.svg',
        top: matchDownSm ? '120%' : '200%',
        right: matchDownSm ? '-50%' : '-20%',
        width: matchDownSm ? '100px' : '200px'
      }}>
      <Features />
      <Licences />
    </DownloadTemplate>
  );
};

export { General as default, General };
